export class SynchronizePlanogramRequest {
  planogramId: string;
  stateId: string;

  constructor(planogramId: string, stateId: string) {
    this.planogramId = planogramId;
    this.stateId = stateId;
  }
}